import React from 'react'
import BottomSheetContent from '../../components/BottomSheetComponents/BottomSheetContent'

interface ElssAlternativesBottomSheetProps {
    onDismiss: () => void
}

export const ElssAlternativesBottomSheet: React.FC<ElssAlternativesBottomSheetProps> = ({ onDismiss }) => {
    return (
        <BottomSheetContent
            heading='Alternative funds for rebalancing ELSS Investments'
            onDismiss={onDismiss}
            bottomSheetBodyClassName='pb-0'
            logoSrc='/images/power-rebalance/manual-book.png'
        >
            <div className='text-sm text-grey10'>
                Given ELSS funds offer no tax benefits in the new tax regime, we recommend you to switch to <strong>top-ranked Flexi Cap or Contra funds</strong> for similar returns and risk profile.
                <br />
                <br />
                <div className="space-y-4">
                    <ul className='list-disc pl-3 text-sm'>
                        <li>
                            <span className="text-grey40">Follow the same steps shown in your recommendation to switch funds.</span>
                        </li>
                        <li>
                            <span className="text-grey40">All Flexi Cap & Contra funds ranked 1, 2, and 3 are strong performers and suitable for switching.</span>
                        </li>
                        <li>
                            <span className="text-grey40">If you prefer a specific Fund House, you’re free to pick any among the Top 3 ranked funds in the same category.</span>
                        </li>
                    </ul>
                </div>
            </div>
        </BottomSheetContent>
    )
}


